import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { GetUserDeposite } from "../../Api/Panel/GetUserDeposite";

export default function Depositpage() {
  const [deposites, setDeposites] = useState([]);

  const GET = async () => {
    const { data } = await GetUserDeposite();
    setDeposites(data);
  };

  useEffect(() => {
    GET();
  }, []);

  return (
    <>
      <div className="flex col-span-4 xl:col-span-4 shadow-md border rounded-lg">
        <div className="py-8 px-5 w-full">
          <h2 className="text-xl lg:text-2xl text-center pb-6 w-full black-color">
            List of your Deposits to buy servers
          </h2>

          <div className="overflow-x-auto relative">
            <table className="w-full text-sm text-left text-gray-400">
              <thead className="text-xs uppercase bg-gray-200 text-gray-800">
                <tr>
                  <th scope="col" className="py-3 px-6">
                    Date
                  </th>
                  <th scope="col" className="py-3 px-6">
                    Transaction Address
                  </th>
                  <th scope="col" className="py-3 px-6">
                    Server Level
                  </th>
                  <th scope="col" className="py-3 px-6">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {deposites.map((el, i) => {
                  let date = new Date(el?.TxDate * 1);
                  date =
                    date.getFullYear() +
                    "/" +
                    (date.getMonth() + 1) +
                    "/" +
                    +date.getDate() +
                    " " +
                    date.getHours() +
                    ":" +
                    date.getMinutes() +
                    ":" +
                    date.getSeconds();
                  return (
                    <tr key={i} className=" bg-gray-100 border-gray-700">
                      <th
                        scope="row"
                        className="py-4 px-6 font-normal whitespace-nowrap text-gray-800"
                      >
                        {date}
                      </th>
                      <td className="py-4 px-6 text-gray-800">{el.TxID}</td>
                      <td className="py-4 px-6 text-gray-800">
                        Level {el.ServerLevel}
                      </td>
                      <td
                        className={`py-4 px-6 ${
                          el.Status === "Pending"
                            ? "text-orange-500"
                            : el.Status === "Confirm"
                            ? "text-green-500"
                            : "text-red-500"
                        }`}
                      >
                        {el.Status}
                      </td>
                    </tr>
                  );
                })}

                <tr className=" bg-gray-100 border-gray-700">
                  <th
                    scope="row"
                    className="py-4 px-6 font-normal whitespace-nowrap text-gray-800"
                  >
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2 rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </th>
                  <td className="py-4 px-6 text-gray-800">
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-6 text-gray-800">
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-6 text-red-500">
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr className=" bg-gray-100 border-gray-700">
                  <th
                    scope="row"
                    className="py-4 px-6 font-medium whitespace-nowrap text-gray-800"
                  >
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </th>
                  <td className="py-4 px-6 text-gray-800">
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-6 text-gray-800">
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-6 text-red-500">
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr className=" bg-gray-100 border-gray-700">
                  <th
                    scope="row"
                    className="py-4 px-6 font-medium whitespace-nowrap text-gray-800"
                  >
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </th>
                  <td className="py-4 px-6 text-gray-800">
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-6 text-gray-800">
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-6 text-red-500">
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr className=" bg-gray-100 border-gray-700">
                  <th
                    scope="row"
                    className="py-4 px-6 font-medium whitespace-nowrap text-gray-800"
                  >
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </th>
                  <td className="py-4 px-6 text-gray-800">
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-6 text-gray-800">
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-6 text-red-500">
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr className=" bg-gray-100 border-gray-700">
                  <th
                    scope="row"
                    className="py-4 px-6 font-medium whitespace-nowrap text-gray-800"
                  >
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </th>
                  <td className="py-4 px-6 text-gray-800">
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-6 text-gray-800">
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-6 text-red-500">
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
